import { Component, OnInit } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { WorkFlowService } from 'src/app/core/services/work-flow.service';
import { CmsService } from 'src/app/core/services/cms.service';
import { CmsObject } from 'src/app/model/cmsobject';
@Component({
  selector: 'ms-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent implements OnInit {
  public smallScreen: boolean = false;
  public notAvailablePage: string ='';
  public cmsObj: CmsObject[];
  constructor(
    private breakpointObserver: BreakpointObserver,
    private workFlow: WorkFlowService,
    public cmsService: CmsService
  ) {

   }

   async ngOnInit() {
    await this.getCmsObj();
    this.breakpointObserver.observe([Breakpoints.XSmall, Breakpoints.Small]).subscribe((result) => {
      this.smallScreen = result.matches;
  });
  }
  async getCmsObj() {
    this.cmsObj = await this.cmsService.getCmsObj(this.workFlow.getLanguageForCms(), 'store');
    this.notAvailablePage = this.cmsObj.find((x) => x.ContentName == 'store.notavailablepage').ContentTranslation;
}


}
